import React from 'react';
import {connect} from 'react-redux';
import {withTheme} from 'styled-components/macro';
import {formatter} from '../utils/utils';
import Tile from './Tile';
import Icon from './Icon';
import Page from './Page';
import Button from './Button';
import Column from './Column';
import DescriptiveText from './DescriptiveText';
import BaseModal from '../../shared/components/modals/types/Base';
import axiosInstance from '../utils/axios';
import debug from 'debug';

const log = debug('circleblack:error');

function mapStateToProps(state) {
  return {
    email: state?.session?.profile?.brand?.advisorCSEmail || state?.product?.brand?.advisorCSEmail,
    phone: formatter('phone')(state?.session?.profile?.brand?.advisorCSPhone || state?.product?.brand?.advisorCSPhone),
  };
}

export const logError = (error, info) => {
  log('Error', error, info);
  axiosInstance.post(
    '/user/feedback',
    {url: window.location.href, type: 'Comment', message: `Unhandled error:\n${error}\n\nAdditional Info:\n${JSON.stringify(info)}`, data: '{}'}
  );
};

export const AppErrorTile = connect(mapStateToProps)(withTheme(
  ({email, phone, theme}) => <Page center={true}>
    <Tile
      title='Something Went Wrong'
      maxWidth='600px'
    >
      <Column>
        <Icon
          width='30px'
          height='30px'
          margin='0 0 10px 0'
          svg={'attention'}
          color={theme.dark ? '#FFCC03' : '#CF790B'}
        />
        <DescriptiveText preset={'paragraph'}>
          We encountered an unexpected issue. Please try refreshing the application.
          If the issue persists please contact Client Services at {email} or {phone}.
        </DescriptiveText>
        <Button
          label={'Refresh Application'}
          importance={'primary'}
          size={'lg'}
          action={() => window.location.reload()}
          width={'fit-content'}
        />
      </Column>
    </Tile>
  </Page>
));

export const PageErrorTile = connect(mapStateToProps)(withTheme(
  ({email, phone, theme}) => <Page center={true}>
    <Tile
      title='Something Went Wrong'
      maxWidth='600px'
    >
      <Column>
        <Icon
          width='30px'
          height='30px'
          margin='0 0 10px 0'
          svg={'attention'}
          color={theme.dark ? '#FFCC03' : '#CF790B'}
        />
        <DescriptiveText preset={'paragraph'}>
          We encountered an unexpected issue on this page. Please try navigating to another page before trying again.
          If the issue persists please contact Client Services at {email} or {phone}.
        </DescriptiveText>
      </Column>
    </Tile>
  </Page>
));

export const ModalError = connect(mapStateToProps)(withTheme(
  ({email, phone, resetErrorBoundary, theme}) => <BaseModal title={'Something Went Wrong'} onClose={resetErrorBoundary}>
    <Column>
      <Icon
        width='30px'
        height='30px'
        margin='0 0 10px 0'
        svg={'attention'}
        color={theme.dark ? '#FFCC03' : '#CF790B'}
      />
      <DescriptiveText preset={'paragraph'}>
        We encountered an unexpected issue with the action you attempted. Please try again.
        If the issue persists please contact Client Services at {email} or {phone}.
      </DescriptiveText>
      <Button
        importance={'primary'}
        size={'md'}
        label={'OK'}
        action={resetErrorBoundary}
      />
    </Column>
  </BaseModal>
));
